import config from 'config'
import {
  ActivityOverviewAssessor,
  AJDetailAssessor,
  AJReportAssessor
} from 'containers/pages'
import React from 'react'
import { get } from 'lodash'

const urlPrefix = `${config.publicPath}/assessor/adventurous-journey/:ajId`


export default [

  {
    path: `${urlPrefix}`,
    component: props => (
      <AJDetailAssessor
        params={get(props, 'match.params', {})}
        {...props}
      />
    ),
    routes: [
      {
        path: `${urlPrefix}/report`,
        component: props => (
          <AJReportAssessor
            params={get(props, 'match.params', {})}
            {...props}
          />
        ),
        routes: []
      },
      {
        path: `${urlPrefix}/overview`,
        component: props => (
          <ActivityOverviewAssessor
            params={get(props, 'match.params', {})}
            {...props}
          />
        ),
        routes: []
      }
    ]
  }
]
